import { TableCell } from "@mui/material"
import { styled } from "@mui/material/styles"
import { useTheme } from "@mui/styles"

export const AssetRegisterRowFirstCell = styled(TableCell)(({ theme }) => ({
    backgroundColor: useGetThemeColourForCells(),
    alignItems: "center",
    justifyContent: "center",
    borderTopLeftRadius: theme.shape.borderRadius,
    borderBottomLeftRadius: theme.shape.borderRadius,
    width: "auto",
}))

export const AssetRegisterRowLastCell = styled(TableCell)(({ theme }) => ({
    backgroundColor: useGetThemeColourForCells(),
    borderTopRightRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
    width: "auto",
}))

export const AssetRegisterRowMiddleCell = styled(TableCell)(() => ({
    backgroundColor: useGetThemeColourForCells(),
    width: "auto",
}))

function useGetThemeColourForCells() {
    const theme = useTheme()
    return theme.palette.background.default
}
